import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import StubPage from '../components/Shared/StubPage';

export default function GraphPage() {
  const { t } = useTranslation();
  return (
    <>
      <div className="page-header">
        <div className="page-title">{t('graph.title')}</div>
        <div className="page-subtitle">{t('graph.subtitle')}</div>
      </div>
      <div className="page-content">
        <StubPage
          icon="🕸"
          title={t('graph.stub.title')}
          description={t('graph.stub.desc')}
        />
      </div>
    </>
  );
}
